"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const venue_1 = require("../../../model/venue");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const right_panel_1 = require("../../../widgets/right_panel");
const venue_table_1 = require("./venue_table");
function renderForm(form) {
    return [
        form.errorBlock(),
        form.field("Nom", "name", "text"),
        form.textarea("Adresse", "address"),
        form.field("Ville", "city", "text"),
        (0, form_for_1.columns)(form.field("Code postal", "postal_code", "text"), form.field("Pays", "country", "text")),
        (0, form_for_1.columns)(form.field("Debut de journée", "planning_starts_at", "text"), form.field("Fin de journée", "planning_ends_at", "text"))
    ];
}
exports.VenueForm = {
    venue: {},
    active: false,
    reset() {
        this.venue = {
            active: true,
            postal_code: "75019",
            country: "France",
            planning_starts_at: "8:00",
            planning_ends_at: "22:00",
        };
    },
    show(venue) {
        if (venue) {
            this.venue = venue;
            if (venue.id) {
                // Reload the contract
                venue_1.VenueProvider.show(this.venue.id).then((venue) => {
                    this.venue = venue;
                    //
                });
            }
        }
        else {
            this.reset();
        }
        this.active = true;
    },
    title() {
        if (this.venue.id !== undefined) {
            return `Editer centre ${this.venue.name}`;
        }
        else {
            return `Nouveau centre`;
        }
    },
    view(_vnode) {
        let form = (0, form_for_1.formFor)(this.venue, venue_1.VenueProvider, (form) => {
            return (0, modal_1.modalCard)({
                title: this.title(),
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Envoyer", {
                    //disabled: (lockingStatus != "ok"),
                    onsubmit: (obj) => {
                        notification_center_1.Notification.success(`L'offre commerciale ${obj.id} a bien été créée.`, (0, mithril_1.default)("a", { href: "#", onclick: () => { right_panel_1.RightPanel.open("commercial_offers", obj.id, "show"); } }, "Afficher"));
                        venue_table_1.VenueTable.fetch();
                        //VenueShow.fetch(obj.id)
                        exports.VenueForm.active = false;
                    }
                })),
                isActive: exports.VenueForm.active,
                onClose: () => { exports.VenueForm.active = false; }
            });
        });
        return form;
    }
};
exports.VenueForm.reset();
